<div *ngIf="inited">
    <sm-toolbar>
        <p-button [disabled]="!isChanged()" icon="fas fa-save" label="Speichern" (onClick)="save()">
        </p-button>
        <p-button icon="fas fa-plus" label="Neu" (onClick)="add()">
        </p-button>
    </sm-toolbar>
    <sm-table [data]="table" [allowInsert]=true [allowDelete]=true [allowSelection]=false [allowExport]=false></sm-table>
</div>
